import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import apiParticipantes from "../api/Participantes/api-participantes";

export const useProyectos = () => {

  const [loading, setLoading] = useState(false);
  const [proyectos, setProyectos] = useState<any>([]);
  const [totalregistrosAceptado, setTotalregistrosAceptado] = useState<number>(0);
  const [totalregistrosPorevaluar, setTotalregistrosPorevaluar] = useState<number>(0);
  const [totalregistrosEvaluado, setTotalregistrosEvaluado] = useState<number>(0);

  const [filtros, setFiltros] = useState<any>({
    palabra_clave: "",
    linea_convocatoria: null,
    categoria: null,
    estado: null
  })

  const coloresEstado: any = {
    Pagado: "#00904C",
    Pendiente: "#4B4B4B"
  }

  const [cantidadPaginas, setCantidadPaginas] = useState(100);;
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPaginas(value);
  }

  const [categoriasLinea, setCategoriasLinea] = useState([]);
  const handleLineaChange = async (id_linea: number) => {
    try {
      const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      console.log(data);
      setCategoriasLinea(data);
      setFiltros({
        ...filtros,
        linea_convocatoria: id_linea
      })
    } catch (error) {
      console.log(error)
    }
  };

  const [lineaConvocatorias, setLineaConvocatorias] = useState([]);
  const obtenerLineaConvocatoria = async () => {
    try {
      const lineasConvocatorias = await apiMaestras.obtenerLineaConvocatoria();
      setLineaConvocatorias(lineasConvocatorias);
    } catch (error) {
      console.log(error)
    }
  };

  const obtenerProyectosByLinea = async () => {
    try {
      let idLinea = filtros.linea_convocatoria
      let { data } = await apiParticipantes.obtenerResultadoEvaluacionByLinea(idLinea);
      data = data.filter((item) => item.estado === "Evaluado" || item.estado === "Por evaluar" || item.estado === "Aceptado" )
      //console.log(data)
      const proyectosFilter = await Promise.all(data.map(async (x, idx) => {
        const postulacion = await getPostulacion(x.id_postulacion);
        return {
          ...x,
          checked: false,
          postulacion,
          index: idx
        };
      }));
      let aceptado = proyectosFilter.filter((x: any) => x.links !== null && (x.estado === 'Aceptado'))
      let porEvaluar = proyectosFilter.filter((x: any) => x.links !== null && (x.estado === 'Por evaluar'))
      let evaluado = proyectosFilter.filter((x: any) => x.links !== null && (x.estado === 'Evaluado'))
      setTotalregistrosEvaluado(evaluado.length)
      setTotalregistrosPorevaluar(porEvaluar.length)
      setTotalregistrosAceptado(aceptado.length)
      return setProyectos(proyectosFilter);
    } catch (error) {
      return console.error(error);
    }
  }

  const obtenerProyectos = async () => {
    // 

    try {
      // const data = await apiJurados.obtenerProyectosJuradosCriterios();
      let { data } = await apiParticipantes.obtenerResultadoEvaluacion();
      data = data.filter((item) => item.estado === "Evaluado" || item.estado === "Por evaluar" || item.estado === "Aceptado" )
      //console.log(data)
      const proyectosFilter = await Promise.all(data.map(async (x, idx) => {
        const postulacion = await getPostulacion(x.id_postulacion);
        return {
          ...x,
          checked: false,
          postulacion,
          index: idx
        };
      }));
      console.log(proyectosFilter);
      
      setLoading(false);
      return setProyectos(proyectosFilter);
    } catch (error) {
      return console.error(error);
    }
  }

  const obtenerProyectosUsuario = async (user) => {
    //
    try {
      // const data = await apiJurados.obtenerProyectosJuradosCriterios();
      // let { data } = await apiParticipantes.obtenerResultadoEvaluacion();
      let { data } = await apiParticipantes.consultarPostulaciones(user.documento)
      data = data.filter((item) => item.estado === "Evaluado")
      //console.log(data)
      const proyectosFilter = await Promise.all(data.map(async (x, idx) => {
        const postulacion = await getPostulacion(x.id_postulacion);
        return {
          ...x,
          checked: false,
          postulacion,
          index: idx
        };
      }));

      let proyectosUsuario = proyectosFilter.filter((item)=> item.postulacion.numero_documento_participante === user.documento)

      setLoading(false);
      return setProyectos(proyectosUsuario);
    } catch (error) {
      return console.error(error);
    }
  }

  const getPostulacion = async (data) => {
    try {
      const postulacion = await apiParticipantes.consultarPostulacion(data);
      //console.log(postulacion.data);
      return postulacion.data;
    } catch (error) {
      console.error(error);
      throw error; // Puedes manejar el error aquí o lanzarlo nuevamente para manejarlo en obtenerProyectos
    }
  }

  const buscarFiltros = () => {
    setLoading(true)
    obtenerProyectosByLinea()
    let filtro = proyectos;
    setProyectos(filtro)
    setLoading(false)
  }

  const limpiarFiltros = () => {
    obtenerProyectos();
    setFiltros({
      palabra_clave: "",
      linea_convocatoria: null,
      categoria: null,
      estado: null
    })
  }

  return {
    proyectos,
    setProyectos,
    cambiarCantidadPaginas,
    cantidadPaginas,
    coloresEstado,
    obtenerLineaConvocatoria,
    obtenerProyectos,
    obtenerProyectosUsuario,
    categoriasLinea,
    loading,
    lineaConvocatorias,
    handleLineaChange,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros,
    totalregistrosAceptado,
    totalregistrosPorevaluar,
    totalregistrosEvaluado
  }
}


